export default __webpack_public_path__ + "static/rec-2010-i-d97f30507d35ae0c8b5ca8c1f92dd26f.png";